import first from './1.jpg';

const inviteLanding = {
    image: first,
    url: 'https://www.ochkov.net/landing/nabor-linz-ochkovnet/index.html',
    content: document.title,
};

export default inviteLanding;
